import { BaseService } from './base.service';
import { CreateOrderRequest, OrderResponse } from '@/types/order.types';

class OrdersService extends BaseService {
  constructor() {
    super('/orders');
  }

  async createOrder(orderData: CreateOrderRequest): Promise<OrderResponse> {
    return this.post<OrderResponse>('', orderData);
  }

  async getOrderById(id: string): Promise<OrderResponse> {
    return this.get<OrderResponse>(`/${id}`);
  }

  async getMyOrders(page: number = 1, pageSize: number = 10): Promise<{ data: OrderResponse[]; total: number; page: number; pageSize: number; totalPages: number }> {
    return this.post<{ data: OrderResponse[]; total: number; page: number; pageSize: number; totalPages: number }>('/list', {
      pagination: {
        page,
        pageSize,
      },
      filters: {},
      /* Newest first. The list used to go out with an empty sort, so it
         came back in insertion order and a member's most recent order
         sat at the bottom of the first page — and, once they had more
         than a page of history, was not on it at all. */
      sort: [{ field: 'createdAt', order: 'desc' as const }],
    });
  }
}

export default new OrdersService();
